
import DataHelpers from './DataHelpers'
import DateHelpers from './DateHelpers'
import { dateFormats } from '../helpers/DateHelpers'

import StringHelpers from './StringHelpers'
import ContactHelpers from './ContactHelpers'
import Utilities from './Utilities'
import ElementHelpers from './ElementHelpers'
import LoanHelpers from './LoanHelpers';
import FileHelpers from './FileHelpers';
import { differenceInCalendarDays } from 'date-fns'


//this file is to replace MergeHelpers which used to work from activities.

export default class {

    static getElementInstance(name) {
        let segmentArray = name.split('_')
        let instance = segmentArray[segmentArray.length - 1]
        return parseInt(instance)
    }

    static merge(str, elements, options) {
        return this.mergeAndAttach(str, elements, options).text
    }

    static mergeAndAttach(str, elements, options) {
        //options can contain:
            // element (ie source element)
            // custom fields straight from the root of options
        //returns {text: xxxx, attachments: []}

        //console.log('MergeHelpers > merge', str)


        let mf = this.findMergeFields(str)
        console.log(mf)

        //let blocks = this.findMergeBlocks(str, 'IF', 'ENDIF')

        let attachments = []

        let instance = 0
        if(options && options.element)
            instance = this.getElementInstance(options.element.name)

        if(!str || !str.match) {
            return {text: '', attachments: []}
        }

        let match = str.match(/\[(.*?)\]/i)

        if(!match)
            return {text: str}

        while(match) {
            let replacement
            let innerMatch = match[1]
            const mergeFieldArray = innerMatch.split('|').map(item => item.trim())
            const mergeField = mergeFieldArray[0]
            const transformsArray = mergeFieldArray.splice(1) //to continue with this...

            //special for outstandings
            if(mergeField.startsWith('outstandings')) {
                let outstandingResult = this.formatOutstanding(mergeField, elements)
                replacement = outstandingResult.text
                this.addUniqueAttachments(outstandingResult.attachments, attachments)
                //attachments = [...attachments, ...outstandingResult.attachments]
            }

            //special for unique fields
            if(!replacement)
                replacement = this.specialField(mergeField, elements)

            //check customfields
            if(!replacement && options)
                replacement = options[mergeField.toLowerCase()]

            let result = {found: false, text: '', attachments: []}

            //try with matching instance number eg. valuation_report_2
            if(!replacement && elements && instance > 1) {
                result = this.lookupItem(mergeField.toLowerCase() + '_' + instance.toString(), elements)
                replacement = result.text
                //attachments = [...attachments, ...result.attachments]
                this.addUniqueAttachments(result.attachments, attachments)

            }

            //email button...

            if(mergeField == 'email_button') {
                const role = transformsArray[0]
                const group = transformsArray[1]
                const template = transformsArray[2]
                const tenantKey = DataHelpers.getTenantKey()
                const transactionKey = DataHelpers.getTransactionKey()
                let path = `${tenantKey}/transaction/${transactionKey}?a=email&g=${group}&t=${template}&r=${role}`
                replacement = StringHelpers.linkToTaco(path, 'Email ' + role)
            }

            //contact card...

            if(mergeField == 'contact_card') {
                const role = transformsArray[0]
                replacement = ContactHelpers.mergeContactCards(role, elements)
            }

            //run normal replacement for everything else...

            if(!replacement && !result.found && elements) {
                result = this.lookupItem(mergeField.toLowerCase(), elements)
                replacement = result.text
                //attachments = [...attachments, ...result.attachments]
                this.addUniqueAttachments(result.attachments, attachments)

            }

            //run transforms

            for(let n = 0; n < transformsArray.length; n++) {
                const transform = transformsArray[n].toLowerCase()
                replacement = this.transformField(transform, replacement)
            }

            //wasn't found, so use curly braces to prevent matching until finished all matches

            if(!replacement && !result.found)
                replacement = '{{' + mergeField + '}}'

            str = str.replace(match[0], replacement)
            match = str.match(/\[(.*?)\]/i)
        }
        str = str.replace(/{{/g, '[').replace(/}}/g, ']')

        //Conditional paragraph block

        match = str.match(/IF\((.*?)ENDIF/)

        while(match) {

            let conditionalText = match[0]
            let expression = match[1].split(')')[0].trim().toLowerCase().replace(/&amp;/g, '&')

            //remove any unmatched fields from expression
            let expressionMatch = expression.match(/\[(.*?)\]/i)
            while(expressionMatch) {
                expression = expression.replace(expressionMatch[0], '')
                expressionMatch = expression.match(/\[(.*?)\]/i)
            }

            let newText = ''
            let expressionResult

            try {
                expressionResult = eval(expression)
            } catch (e) {
                expressionResult = false
            }
            if(expressionResult)
                newText = match[1].split(')')[1].replace('ENDIF', '')

            str = str.replace(conditionalText, newText)
            match = str.match(/IF\((.*?)ENDIF/)
        }

        //Formula evaluation

        match = str.match(/\<FORMULA\>(.*?)\<\/FORMULA\>/)
        while(match) {
            const outerMatch = match[0]
            const formulaExpression = match[1]
            let evaluation = '(?)'
            try {

                evaluation = eval(formulaExpression)
            } catch (err) {
                console.log('Formula evaluation failed on ' + formulaExpression)
            }

            str = str.replace(outerMatch, evaluation)
            match = str.match(/\<FORMULA\>(.*?)\<\/FORMULA\>/)
        }

        str = str.replace(/1==1/g, '') //check if this is needed

        return {text: str, attachments}
    }


    //not used yet....
    static findMergeBlocks(text, startWord, endWord) {
        let re = new RegExp(startWord + '(.*?)' + endWord, 'g')
        let matches = text.match(re) || []
        let results = []

        matches.forEach(block => {

            let expressions = block.match(/\(.*?\)/g)
            if(expressions.length) {
                const outerExpression = expressions[0]
                const innerExpression = outerExpression.replace('(', '').replace(')', '')
                const content = block.replace(outerExpression, '').replace(startWord, '').replace(endWord, '')
                results.push({
                    outerExpression,
                    innerExpression,
                    content
                })

            }
        })

        console.log(results)
        return matches
    }

    static addUniqueAttachments(fromArray, toArray) {
        fromArray.forEach(attachmentObject =>{
            const existing = toArray.find(o => o.path == attachmentObject.path)
            if(!existing)
                toArray.push(attachmentObject)

        })
    }

    static transformField(transform, replacement) {

        if(transform == 'lower')
            return replacement.toLowerCase()
        if(transform == 'integer')
            return StringHelpers.formatInteger(replacement)
        if(transform == 'first')
            return StringHelpers.firstWord(replacement)
        if(transform == 'days') {
            const dateStr = replacement.split(' ')[1]
            const dateVal = DateHelpers.toDate(dateStr)
            return differenceInCalendarDays(dateVal, new Date())
        }
        else
            return replacement
    }

    // static lookupItem(value, elements) {

    //     let matchingElements = elements.filter(o => o.name && o.value && o.name.toLowerCase() == value.toLowerCase())

    //     let resultArray = []
    //     matchingElements.forEach(element => {
    //         resultArray.push(this.formatElement(element))
    //     })

    //     return StringHelpers.sentenceJoin(resultArray)
    // }

    static lookupItem(value, elements) {

        let matchingElements = elements.filter(o => o.name && o.value && o.name.toLowerCase() == value.toLowerCase())
        let result = {
            found: false,
            attachments: [],
            replacements: [],
            text: ''
        }
        let resultArray = []
        let resultAttachments = []

        matchingElements.forEach(element => {
            if(element.type=="File") {
                result.attachments.push({
                    path: element.value,
                    name: FileHelpers.fileNameFromStoragePath(element.value),
                    fileName: element.fileName,
                })
                result.replacements.push('1==1')
                result.found = true
            }
            //Everything apart from files...
            else {
                result.replacements.push(this.formatElement(element))
                result.found = true
            }
        })

        result.text = StringHelpers.sentenceJoin(result.replacements)

        return result
    }

    static formatElement(element, elements) {

        let result = ''
        if(element.type == 'File')
            result = this.formatFileLink(element)
        else if(element.type == 'Html')
            result = this.merge(element.value, elements)
        else if(element.type == 'LoanAttributes')
            result = ElementHelpers.loanAttributes()
        else if(element.type == 'Currency')
            result = StringHelpers.formatCurrency(element.value)
        else if(element.type == 'Checkbox')
            result = element.value ? 'Yes' : 'No'
        else if(element.type == 'Contact')
            result = ContactHelpers.fullName(element.contact)
        else if(element.type == 'Outstanding')
            result = '<b>' + element.text + '</b><br>' + element.response + '<br>'
        else if(element.type == 'Date' && element.value)
            result = DateHelpers.convertDate(element.value, dateFormats.BACKWARDS, 'EEEE d MMM')
        else if(element.type == 'DateTime' && element.value)
            result = DateHelpers.dateTimeToText(element.value)
        else if(element.type == 'Rating')
            result = element.value.toString() + ' stars'
        else if(element.value && element.value.startsWith('http'))
            result = '<a target="blank" style="color:white;text-decoration:none" href="' + element.value + '"><div @click.stop.prevent style="text-align:center;background-color:#42A5F5;padding:3px 10px 3px 10px;border-radius:13px;font-size:12px;font-weight:500;display:inline-block;max-width:200px;" title="' + element.value + '">' + element.title + '</div></a>'
        else
            result = element.value


        // if(result && !isNaN(result)){
        //     result = StringHelpers.formatNumber(result)
        // }

        return result
    }

    static formatFileLink(element) {
        return '<a href="' + element.value + '" title="' + element.title + '" style="text-decoration:none"><img width="20" style="vertical-align:middle" src="' + StringHelpers.imagePath() + 'pdf-icon.png' + '"/>&nbsp;&nbsp;' + (element.fileName || element.title) + '</a>&nbsp;&nbsp;'
    }

    static formatLink(element) {
        return '<a href="' + element.value + '" style="text-decoration:none"><img width="20" style="vertical-align:middle" src="' + StringHelpers.imagePath() + 'pdf-icon.png' + '"/>&nbsp;&nbsp;' + element.title + '</a>&nbsp;&nbsp;'
    }

    static specialField(mergeField, elements) {
        if(mergeField == 'transaction_link') {
            return '<a href="' + window.location.href + '" target="_blank" >Transaction</a>'
        }
        if(mergeField == 'loan_structure') {
            let loanElement = LoanHelpers.loanElement()

            if(loanElement.version == 2) {
                return loanElement.value
            } else {
                let diagramDetails = LoanHelpers.diagramDetails(loanElement.diagram)
                return LoanHelpers.diagramDescription(diagramDetails)
            }
        }
    }

    static formatOutstanding(mergeField, elements) {
        let result = {
            replacements: [],
            attachments: [],
            text: '',
        }

        if(mergeField == 'outstandings_to_client') {

            let filteredElements = elements.filter(o => o.name == 'outstanding' && o.status == 'Waiting for Client')

            filteredElements.forEach(element => {
                // let outputStr = '<b>' + element.text + '</b>'
                let outputStr = element.text
                result.replacements.push(outputStr)
            })
        }

        if(mergeField == 'outstandings_sent') {
            let filteredElements = elements.filter(o => o.name == 'outstanding' && o.status == 'Sent')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })
        }

        if(mergeField == 'outstandings_settlement') {

            const filteredElements =  elements.filter(o => o.name == 'outstanding' && o.status == 'Settlement Condition')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })
        }

        if(mergeField == 'outstandings_broker') {

            const filteredElements =  elements.filter(o => o.name == 'outstanding' && o.status == 'Waiting for Broker')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })
        }

        if(mergeField == 'outstandings_processor') {

            const filteredElements =  elements.filter(o => o.name == 'outstanding' && o.status == 'Waiting for Processor')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })
        }

        if(mergeField == 'outstandings_lender') {

            let filteredElements = elements.filter(o => o.name == 'outstanding' && o.status == 'Lender to Complete')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })

        }

        if(mergeField == 'outstandings_to_lender') {
            let filteredElements = elements.filter(o => o.name == 'outstanding' && o.status == 'Ready to Send')

            filteredElements.forEach(element => {
                let outputStr = '<b>' + element.text + '</b>'
                outputStr += element.response ? '<br>' + element.response : ''
                let fileElements = ElementHelpers.filesForElement(element, elements)
                if(fileElements.length) {
                    outputStr += '<br><br>See attached: '
                    fileElements.forEach(fileElement => {
                        //if send as link then could do the following
                        //outputStr += this.formatFileLink( fileElement )
                        outputStr += fileElement.title + ' '

                        result.attachments.push({
                            path: fileElement.value,
                            name: FileHelpers.fileNameFromStoragePath(fileElement.value),
                        })
                    })
                }
                result.replacements.push(outputStr)
            })

            if(result.replacements.length) {
                result.text = result.replacements.join('<br><br>')
                return result
            }
        }

        if(mergeField == 'outstandings') {
            let filteredElements = elements.filter(o => o.name == 'outstanding' && o.status != 'Sent')

            filteredElements.forEach(element => {
                let outputStr = '<b>' + element.text + '</b> (' + element.status + ')'
                outputStr += element.response ? '<br>' + element.response : ''
                let fileElements = ElementHelpers.filesForElement(element, elements)
                outputStr += (fileElements.length ? '<br>' : '')
                fileElements.forEach(fileElement => {
                    outputStr += this.formatFileLink( fileElement )

                })
                result.replacements.push(outputStr)
            })

        }

        if(mergeField == 'outstandings_text') {
            let filteredElements = elements.filter(o => o.name == 'outstanding')

            filteredElements.forEach(element => {
                let outputStr = element.text
                result.replacements.push(outputStr)
            })

            if(result.replacements.length) {
                result.text = result.replacements.join('<br/>')
                return result
            }
        }

        if(result.replacements.length) {
            result.text = '<ul><li>' + result.replacements.join('</li><li>') + '</li></ul>'
            result.text = result.text.replace(/'/g, '')
        }

        return result
    }

    static lookup(str) {
        return new Promise(function(resolve, reject) {
            let match = str.match(/LOOKUP\((.*?)\)/i)
            while(match) {


                let innerMatch = match[1]
                let outerMatch = match[0]
                let innerMatchBrackets = '{{' + innerMatch + '}}'

                str = str.replace(outerMatch, innerMatchBrackets)

                if(innerMatch.indexOf('[') < 0) {
                    let ref = DataHelpers.getTenantRef().child('data').child(innerMatch)

                    ref.once('value', function(snap) {
                        //console.log('snapval', snap.val())
                        let result = snap.val() || '* Not Found *'
                        resolve( str.replace(innerMatchBrackets, result) )
                    })
                } else
                    resolve(str.replace(innerMatchBrackets, '* More Info Needed *'))


                match = str.match(/LOOKUP\((.*?)\)/i)
            }
        })
    }

    static isFormula(str) {
        str = str || ''

        if(str.indexOf("'") > -1 || str.indexOf("[") > -1)
            return true

        return false
    }

    static parseFormula(str, elements) {

        str = str || ''

        if(!elements || elements.length < 1) {
            return "No elements passed"
        }

        //Don't merge if not a formula...
        if(!this.isFormula(str))
            return str

        let mergeFields = this.findMergeFields(str)
        let parsedString = this.replaceMergeFields(str, mergeFields, elements)
        //console.log(parsedString)
        try {
            return eval(parsedString)
        } catch (err) {
            console.log('Invalid formula', err)
            return 'Invalid formula'
        }
    }


    static findMergeFields(searchString) {

        //console.log('findMegeFields', searchString)

        let matches = {}
        let match

        do {
            match = String(searchString).match(/\[(.*?)\]/i)
            if(!match)
                break

            let innerMatch = match[1]
            let outerMatch = match[0]

            matches[innerMatch] = true
            searchString = searchString.replace(outerMatch, '')

        } while(match)

        return Utilities.objectToArray(matches)
    }

    static replaceMergeFields(str, mergeFieldsArray, elements) {
        mergeFieldsArray.forEach((mergeField) => {
            let matchingObject = elements.find( o => o.name == mergeField)
            if(matchingObject) {
                let matchingValue = matchingObject.value
                let searchString = '[' + mergeField + ']'
                str = str.replace(searchString, matchingValue)
            }
        })
        return str
    }

    static getDateMerge(field) {
        today = new Date()
        days = 1000 * 60 * 60 * 24
        if(field == 'today')
            return DateHelpers.todayString()
        else if(field == 'tomorrow')
            return DateHelpers.tomorrowString()
        return null
    }

    static simpleMerge(text, mergeItems) {
        for(let name in mergeItems) {
            text = text.replace('[' + name + ']', (mergeItems[name] || ''))
        }
        return text
    }



    //new for record based fields

    static mergeRecord(str, mergeFieldsArray, record) {

        mergeFieldsArray.forEach((mergeField) => {
            str = str.replace(/=/g, '==').replace(/====/g, '==')
            str = str.replace(/OR/g, '||').replace(/AND/g, '&&')

            str = str.replace('[tenantKey]', DataHelpers.getTenantKey() )

            let replacement = record[mergeField]
            if(replacement != null)
                str = str.replace('[' + mergeField + ']', replacement)
            else
                str = str.replace('[' + mergeField + ']', '"Not found: ' + mergeField + '"')
        })
        return str
    }



}


// WEBPACK FOOTER //
// ./src/helpers/MergeHelpers.js